import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStatus, IDataInput } from '../../../../interface/interfaces';

interface IInitialState {
    statusLoading: boolean;
    statusData: IStatus[];
    statusError: string;
}

const initialState: IInitialState = {
    statusLoading: false,
    statusData: [],
    statusError: '',
};

const statusSlice = createSlice({
    name: 'commits',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchStatusPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.statusLoading = true;
            state.statusData = [];
        },

        fetchStatusFulfilled: (state: IInitialState, action: PayloadAction<IStatus[]>) => {
            state.statusLoading = false;
            state.statusData = action.payload;
            state.statusError = '';
        },

        fetchStatusFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.statusLoading = false;
            state.statusData = [];
            state.statusError = action.payload;
        },
    },
});

export default statusSlice.reducer;
export const { fetchStatusPending, fetchStatusFulfilled, fetchStatusFailure } = statusSlice.actions;
